import { Icon } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@heroicons/react/solid';
import { Badge } from '@lib/docs/components/badge';
import clsx from 'clsx';

type Props = {
  isActive?: boolean;
  isExternal?: boolean;
  icon?: React.FunctionComponent;
  text: string;
  size?: 'sm' | 'md';
  tag?: string;
};

export function SidenavItem({
  isActive = false,
  isExternal = false,
  icon,
  text,
  size = 'md',
  tag
}: Props): JSX.Element {
  return (
    <div
      data-group
      className={clsx(
        'group flex items-center gap-4 rounded-md px-4 py-2 transition',
        {
          'bg-gray-950/5 text-gray-950 dark:bg-gray-50/5 dark:text-white':
            isActive,
          'bg-transparent text-slate-500 dark:text-gray-400': !isActive
        }
      )}
    >
      {icon && (
        <Icon
          as={icon}
          transition="all 0.15s"
          color={isActive ? 'var(--primaryTextColor)' : 'var(--iconColor)'}
          _groupHover={{
            color: 'var(--primaryTextColor)'
          }}
        />
      )}
      <div className="flex items-center gap-1">
        <p
          className={clsx(
            'font-medium group-hover:text-gray-950 group-hover:dark:text-white',
            {
              'text-[13px]/5': size === 'sm',
              'text-sm/5': size === 'md'
            }
          )}
        >
          {text}
        </p>
        {isExternal && (
          <Icon
            as={ExternalLinkIcon}
            _groupHover={{
              color: 'var(--primaryTextColor)'
            }}
          />
        )}
      </div>
      {tag === 'Community' && <Badge label={tag} />}
    </div>
  );
}
